/**
 * Company-related constants
 */

export const ARTYC_COMPANY_NAME = 'artyc';
export const ARTYC_PARTNER_LABEL = 'Artyc Partner';
export const CALIBRATION_LAB_COMPANY_NAME = 'calibration lab';

export const ARTYC_ACCOUNT_NAMES = [
  'artyc',
  'frosty pharmaceuticals',
  'polar bio',
  'test company',
  'uw health test',
] as const;
